// extracted by mini-css-extract-plugin
export default {"loading":"Devices_loading__vpWks","statusCellule":"Devices_statusCellule__-DotC","tooltipTagContainer":"Devices_tooltipTagContainer__+oz5n"};